// Common
import { IllumioDaq } from "../common/illumio_daq.js";
import { IllumioSearch } from "../common/illumio_search.js";

// Software
import { SoftwareNavigationModel, SoftwareNavigationView, SoftwareNavigationController } from "../software/navigation-mvc.js";
import { SoftwareContentModel, SoftwareContentView, SoftwareContentController } from "../software/content-mvc.js";

// Software OS Support
import { PceOsSupportModel, PceOsSupportView, PceOsSupportController } from "../os_support/pce.js";
import { VenOsSupportModel, VenOsSupportView, VenOsSupportController } from "../os_support/ven.js";
import { New_venOsSupportModel, New_venOsSupportView, New_venOsSupportController } from "../os_support/new_ven.js";
import { CliOsSupportModel, CliOsSupportView, CliOsSupportController } from "../os_support/cli.js";
import { EndpointOsSupportModel, EndpointOsSupportView, EndpointOsSupportController } from "../os_support/endpoint.js";
import { FlowlinkOsSupportModel, FlowlinkOsSupportView, FlowlinkOsSupportController } from "../os_support/flowlink.js";
import { ContainerOsSupportModel, ContainerOsSupportView, ContainerOsSupportController } from "../os_support/container.js";
import { NenOsSupportModel, NenOsSupportView, NenOsSupportController } from "../os_support/nen.js";

// Training
import IllumioTrainingContent from "../training/content.js";
import { IllumioTrainingLanguageCourse } from "../training/language-course.js";
import TrainingCoursesFilter from "../training/courses-filter.js";
import IllumioVideo from "../training/video.js";

// Account and Profile
import { ProfileModel, ProfileView, ProfileController } from "../account/profile.js";
import { ContactModel, ContactView, ContactController } from "../account/contact.js";
import { AccountContactListModel, AccountContactListView, AccountContactListController } from "../account/contact_list.js";
import { UcRequestModel, UcRequestView, UcRequestController } from "../account/uc_request.js";
import { TrainingSubscriptionListModel, TrainingSubscriptionListView, TrainingSubscriptionListController } from "../account/training_subscription_list.js";

// Knowledge
import { KnowledgeBaseFeedbackModel, KnowledgeBaseFeedbackView, KnowledgeBaseFeedbackController } from "../knowledge/knowledge_base-feedback-mvc.js";
import { KnowledgeBaseDownloadModel, KnowledgeBaseDownloadView, KnowledgeBaseDownloadController } from "../knowledge/knowledge_base-download-mvc.js";

// Tools
import ToolsHome from "../tools/home.js";
import { IloToolDownloadForm, IloToolsModal, IloToolsFeedbackForm, IloToolsFeedbackSubmitModal } from "../tools/legacy.js";

// Documenation
import IllumioDocumentationArchivesTOC from "../documentation_archives.js";

export class IllumioSupportTemplate {
    isDebug = true;

    constructor() {
        // Alternative for future consideration: windows.onload handler
        document.addEventListener('DOMContentLoaded', this.domContentLoadedHandler.bind(this));

        if (!document.getElementById('publicElement')) {
            const illumioDaq = new IllumioDaq();
            console.debug(`» illumioDaq: `, illumioDaq);
        }
    }

    domContentLoadedHandler(event) {
        console.debug(`IllumioSupportTemplate.domContentLoadedHandler(): this.isDebug: ${this.isDebug}`);

        this.highlightTopNavigation();
        this.highlightLeftNavigation();

        this.initializeDrawerSide('topNavigationDrawerSide', 'topNavigationDrawerToggle');
        this.initializeDrawerSide('contentNavigationDrawerSide', 'contentNavigationDrawerToogle');

        // Update search form (i.e., icons, etc)
        if (!document.getElementById('publicElement')) {
            new IllumioSearch();
            this.initializeHomepageSearchBanner();
        }

        this.initializeCopyrightYear();

        console.debug(`IllumioSupportTemplate.domContentLoadedHandler()`, event);
        if (location.pathname.match(/^\/software\/(index|download)(\.htm(l)?)?$/)) {
            console.debug(`» Detected Software Download`);
            this.initializeSoftwareDownload();
        } else if (location.pathname.match(/^(\/shared)?\/software\/os-support-package-dependencies\//)) {
            console.debug(`» Detected OS Support`);
            this.initializeOsSupport();
        } else if (location.pathname.match(/^(\/shared)?\/training\//)) {
            console.debug(`» Detected Training`);
            this.initializeTraining();
        } else if (location.pathname.match(/^\/knowledge\-base\/articles\//)) {
            console.debug(`» Detected Knowledge`);
            this.initializeKnowledge();
        } else if (document.getElementById('theProfileForm')) {
            const profileModel = new ProfileModel();
            new ProfileController(profileModel, new ProfileView(profileModel));
        } else if (document.getElementById('contactListDesktop')) {
            const model = new AccountContactListModel();
            new AccountContactListController(model, new AccountContactListView(model));
        } else if (document.getElementById('ucActivationForm')) {
            const model = new UcRequestModel();
            new UcRequestController(model, new UcRequestView(model));
       } else if (document.getElementById('illumioDaqAutomation')) {
            console.debug(`» Detected IllumioDaqAutomation`);
            const illumioDaq = new IllumioDaq();
            console.debug(illumioDaq.data);
        } else if (document.getElementById('illumioContact')) {
            console.debug(`» Detected Contact`);
            const model = new ContactModel();
            new ContactController(model, new ContactView(model));
        } else if (document.getElementById('trainingSubscriptions')) {
            const model = new TrainingSubscriptionListModel();
            new TrainingSubscriptionListController(model, new TrainingSubscriptionListView(model));
        } else if (location.pathname.match(/^\/tools\/index/)) {
            console.debug(`» Tools home`);
            ToolsHome.initialize();
        } else if (document.getElementById('toolsContent')) {
            IloToolDownloadForm.initialize();
            IloToolsModal.initialize();
            IloToolsFeedbackForm.initialize();
            IloToolsFeedbackSubmitModal.initialize();
        } else if (document.getElementById('theDocumentationArchivesContent')) {
            console.debug(`» Dectected theDocumentationArchivesContent`);
            IllumioDocumentationArchivesTOC.initialize();
        }
    }

    /**
     * Highlight top navigation.
     */
    highlightTopNavigation() {
        const topnavLinks = document.querySelectorAll('#navbarHeader ul.menu-horizontal > li > a');
        const paths = location.pathname.split(/\//);
        if (topnavLinks.length>0 && paths && paths.length>1 && paths[1]!='' && paths[1]!='index.html') {
            let matchingLevel1 = `/${paths[1]}`;
            if ((paths[1]=='support' || paths[1]=='apex' || paths[1]=='shared') && paths.length>2) {
                matchingLevel1 = `/${paths[2]}`;
            }
            for (const topnavAnchor of topnavLinks) {
                // console.debug(`highlightTopNavigation(): matchingLevel1 ${matchingLevel1} in ${topnavAnchor.href}`);
                // console.debug(topnavAnchor);
                if (topnavAnchor.href && (
                        topnavAnchor.href.indexOf(matchingLevel1)>0 ||
                        (topnavAnchor.href.indexOf('/search')>0 && paths[1]==='knowledge-base'))) {
                    topnavAnchor.parentElement.classList.add('menu-active');
                    break;
                }
            }
        }
    }

    /**
     * Highlight left navigation. 
     * Does not apply to tools page.
     */
    highlightLeftNavigation() {
        if (document.querySelector('.tools-left-navigation')) {
            // console.debug(`highlightLeftNavigation(): Detected Tools Left Navigation. Skipping!`);
            return;
        }

        const links = document.querySelectorAll('#contentNavigationDrawerSide a');
        if (document.location.pathname.length>1) {
            for (const link of links) {
                // console.debug(`» link.pathname: `, link.pathname);
                if (link.pathname.length>1 && link.pathname.indexOf(document.location.pathname)>=0) {
                    console.debug(`Found the match: `, link.pathname, `vs`, document.location.pathname);
                    link.classList.add('menu-highlight');
                    // Note: DaisyUI v5 caveat: the nemu-active applies to sub-menu. We don't want that.
                    // if (link.parentElement.tagName==='LI') {
                    //     link.parentElement.classList.add('menu-active');
                    // }
                    break;
                }
            }
        }
    }

    /**
     * Initialize home page search banner by relocating it so the background can expand across the page.
     * Assumption: #homepageSearchBanner exists in the page of the website.
     */
    initializeHomepageSearchBanner() {
        const outerMain = document.getElementById('outerMain');
        const homepageSearchBanner = document.getElementById('homepageSearchBanner');
        if (homepageSearchBanner && outerMain) {
            const secondaryDivElement = document.createElement('div');
            secondaryDivElement.classList.add('w-full');
            secondaryDivElement.classList.add('flex');
            secondaryDivElement.classList.add('flex-col');
            secondaryDivElement.classList.add('items-center');

            for (const childElemenet of outerMain.children) {
                secondaryDivElement.append(childElemenet);
            }
            secondaryDivElement.prepend(homepageSearchBanner);
            outerMain.append(secondaryDivElement);
        }
    }

    /**
     * Update the copyright year.
     */
    initializeCopyrightYear() {
        const copyrightYear = document.getElementById('copyrightYear');
        if (copyrightYear) {
            copyrightYear.innerHTML = new Date().getFullYear();
            // if (IllumioSupportTemplate.isDebug) {
            //     console.debug(`IllumioSupportTemplate: domContentLoadedHandler(): Updated ${copyrightYear}`);
            // }
        }
    }

    /**
     * Initialize content navigation drawer side to close the left navigation when clicking anywhere in the menu.
     */
                                                                             
    initializeDrawerSide(drawerSide='topNavigationDrawerSide', drawerToggle='topNavigationDrawerToggle') {
        const drawerSideElement = document.getElementById(drawerSide);
        const drawerToogleElement = document.getElementById(drawerToggle);
        if (this.isDebug) {
            console.debug(`initializeDrawerSide(): `);
            console.debug(drawerSideElement);
            console.debug(drawerToogleElement);
        }
        if (drawerSideElement && drawerToogleElement) {
            window.addEventListener('keydown', (event) => {
                // if (this.isDebug) {
                //     console.debug(`drawerSideElement: keydown Event`);
                //     console.debug(event);
                //     console.debug(`» event.key: ${event.key}`);
                // }
                if (event.key==='Escape' && drawerToogleElement.checked) {
                    drawerToogleElement.checked = false;
                }
            });
            drawerSideElement.addEventListener('click', (event) => {
                // if (this.isDebug) {
                //     console.debug(`drawerSideElement: click Event`);
                //     console.debug(event);
                //     console.debug(event.currentTarget);
                //     console.debug(event.target);
                //     console.debug(`» drawerToogleElement.checked: ${drawerToogleElement.checked}`);
                // }
                if (event.target.tagName!=='LABEL' && drawerToogleElement.checked) {
                    drawerToogleElement.checked = false;
                }
            });
        }
    }

    initializeSoftwareDownload() {
console.info(this);
        if (this.isDebug) console.debug('initializeSoftwareDownload(): Initializing Software Navigation and Content');
        try {
            const softwareNavigationModel = new SoftwareNavigationModel();
            const softwareNavigationView = new SoftwareNavigationView(softwareNavigationModel);
            this.softwareNavigationController = new SoftwareNavigationController(softwareNavigationModel, softwareNavigationView);
            if (this.isDebug) console.debug('initializeSoftwareDownload(): Initialized Software Navigation');

            const softwareContentModel = new SoftwareContentModel();
            const softwareContentView = new SoftwareContentView(softwareContentModel);
            this.softwareContentController = new SoftwareContentController(softwareContentModel, softwareContentView, this.softwareNavigationController);
            if (this.isDebug) console.debug('initializeSoftwareDownload(): Initialized Software Content');
        } catch (error) {
            if (this.isDebug===true) console.error(error);
            console.debug('initializeSoftwareDownload(): Unable to initialize software content!');
        }
    }

    initializeOsSupport() {
        if (location.pathname.match(/\/pce.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected PCE`);
            const model = new PceOsSupportModel();
            const view = new PceOsSupportView(model);
            // const controller = new PceOsSupportController(model, view);
        } else if (location.pathname.match(/\/ven.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected VEN`);
            const model = new VenOsSupportModel();
            const view = new VenOsSupportView(model);
            // const controller = new VenOsSupportController(model, view);
        } else if (location.pathname.match(/\/new_ven.html$/)) {
            const model = new New_venOsSupportModel();
            const view = new New_venOsSupportView(model);
            // const controller = new New_venOsSupportController(model, view);
        } else if (location.pathname.match(/\/cli.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected CLI`);
            const model = new CliOsSupportModel();
            const view = new CliOsSupportView(model);
            // const controller = new CliOsSupportController(model, view);
        } else if (location.pathname.match(/\/endpoint.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected Endpoint`);
            const model = new EndpointOsSupportModel();
            const view = new EndpointOsSupportView(model);
            // const controller = new EndpointOsSupportController(model, view);
        } else if (location.pathname.match(/\/flowlink.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected Endpoint`);
            const model = new FlowlinkOsSupportModel();
            const view = new FlowlinkOsSupportView(model);
            // const controller = new FlowlinkOsSupportController(model, view);
        } else if (location.pathname.match(/\/kubernetes_operator.html$/)) {
            if (this.isDebug) console.debug(`IllumioSupportTemplate.initializeOsSupport(): Detected Kubernetes Operator`);
            const model = new ContainerOsSupportModel('kubernetes_operator', 'Kubernetes Operator');
            const view = new ContainerOsSupportView(model);
            // const controller = new ContainerOsSupportController(model, view);
        } else if (location.pathname.match(/\/lw-ven.html$/)) {
            const model = new ContainerOsSupportModel('lw_ven', 'Legacy Windows VEN');
            const view = new ContainerOsSupportView(model);
            // const controller = new ContainerOsSupportController(model, view);
        } else if (location.pathname.match(/\/nen.html$/)) {
            const model = new NenOsSupportModel();
            const view = new NenOsSupportView(model);
            // const controller = new NenOsSupportController(model, view);
        }
    }

    initializeTraining() {
        if (document.getElementById('coursesContainer')) {
            new IllumioTrainingLanguageCourse();
        }
        if (document.getElementById('certificationProgram') && IllumioTrainingContent) {
            IllumioTrainingContent.populateImage('certificationProgram');
            IllumioTrainingContent.populateImage('certificationProcess');
        }
        if (document.getElementById('theCourseCatalogFilter')) {
            TrainingCoursesFilter.init(document.getElementById('theCourseCatalogFilter'));
        }

        const videoContainer = document.getElementById('subscriptionVideoContainer');
        if (videoContainer) {
            const video = {
                id: 'zaqroz3i3f',
                title: 'Product Training Annual Subscription',
            }
            videoContainer.dataset['id'] = video.id;
            videoContainer.dataset['hash'] = IllumioVideo.urlSafe(video.title);
            
            const h2s = videoContainer.getElementsByTagName('H2');
            if (h2s.length>0) {
                h2s[0].textContent = video.title;
            }

            videoContainer.onclick = IllumioVideo.videoContainerOnClickHandler;
        } else {
            console.warn('subscriptionVideoContainer undetected!');
        }

        // Illumio Free Training Videos
        if (document.getElementById('trainingVideosContainer')) {
            const videos = document.querySelectorAll('#trainingVideosContainer .video-card');
            for (const video of videos) {
                video.onclick = IllumioVideo.videoCardOnClickHandler;
            }
        }

    }

    initializeKnowledge() {
        if (document.getElementById('kbFeedbackForm')) {
            console.debug(`» Detected kbFeedbackForm`);
            const model = new KnowledgeBaseFeedbackModel();
            new KnowledgeBaseFeedbackController(model, new KnowledgeBaseFeedbackView(model));
        }

        if (document.getElementById('kbDownloadForm')) {
            console.debug(`» Detected kbDownloadForm`);
            const downloadModel = new KnowledgeBaseDownloadModel();
            new KnowledgeBaseDownloadController(downloadModel, new KnowledgeBaseDownloadView(downloadModel));
        }
    }
}

